import React,{useMemo, useState} from "react";
import axios from 'axios';
import { useTable,useRowSelect } from 'react-table';

import CertificationDetail from './CertificationDetail';
import MakePDFCertifications from './MakePDFCertifications';
import {MakeExcelFileForDownload,CloseExcelPopup,IndeterminateCheckbox,SetBasePageStatus,PassedMonths,ChangeSimpleDateString} from "../../../components/common/Common";
import removeIcon from "../../../img/icon/icon-circle-minus.svg";

const CertificationSearchResult = ({varTotalCount,varColumnLists,varLevelList,varCertificationLists,GetCertificationList,varSearchData}) => {
  //컬럼 - 제목부
  const columns = useMemo(() => {
    return varColumnLists; 
    // eslint-disable-next-line
  },[varColumnLists]);

  //표시할 정보
  const data = useMemo(() => {
    return varCertificationLists;
    // eslint-disable-next-line
  }, [varCertificationLists]);

  //발급 현황 변경
  /* const [varChangeStatus,setChangeStatus] = useState(0); */

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, selectedFlatRows} 
    = useTable({ columns, data, initialState:{hiddenColumns:["ce_idx","ce_status","vl_terms"]}},useRowSelect, 
      hooks => {
        hooks.visibleColumns.push(columns => [
          {
            id: 'selection',
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <div style={{width:"20px"}}>
                <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
              </div>
            ),
            Cell: ({ row }) => (
              <div style={{width:"40px"}}>
                <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
              </div>
            )
          },
          ...columns,
        ])
      }
  );

  //세부항목 보기
  const [varShowDetail, setShowDetail] = useState(false);
  const [varDetailInfo, setDetailInfo] = useState({});
  const onShowDetailHandler = (e,ce_idx) => {
    const detailInfo = varCertificationLists.find(el=>el.ce_idx===ce_idx);
    setDetailInfo(detailInfo);
    SetBasePageStatus(true);
    setShowDetail(true);
  }
  //팝업창 닫기
  const CloseCertificationDetail = () => {
    SetBasePageStatus(false);
    setShowDetail(false);
  }

  /* //발급현황
  const onChangeStatusHandler = (e) => {
    setChangeStatus(Number(e.target.value));
  }
  
  //일괄적용
  const onChangeStatusAllHandler = async(e) => {
    //선택된 수료중 발급 갯수
    var iselected = selectedFlatRows.length;
    if(iselected === 0) {
      alert(`발급현황을 변경할 내역이 선택되어 있지 않습니다.`);
      return false;
    }

    let certIndexString = "";
    for(var i=0; i < iselected; i++) {
      var sline = selectedFlatRows[i].values['ce_idx'];
      certIndexString = AddOptionToString(sline,certIndexString,',');
    }

    if (!window.confirm(iselected+'개의 발급현황을 변경합니까?')) return false;
    const sendData = {certIndexString: certIndexString,cMode:varChangeStatus};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_change_certification_list`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        GetCertificationList();
      } else {
        alert(res.data.message);
      }
    }); 
  } */

  //엑셀 다운로드--------------------------------------------------------
  //엑셀다운 범위 선택창 표시
  const onSelectDownloadModeHandler = (e) => {
    const popupWin = document.querySelector('.excel-buttons');
    if(popupWin.classList.contains('hide')) popupWin.classList.remove('hide');
  }
  //엑셀로 다운로드 방식 선택후
  const onDownloadExcelHandler = (e,imode) => {
    var iselected = selectedFlatRows.length;
    console.log(iselected);
    const popupWin = document.querySelector('.excel-buttons');
    if(!popupWin.classList.contains('hide')) popupWin.classList.add('hide');
    if(imode === 1) MakeExcelFileForDownload(varColumnLists,varCertificationLists,'수료증');
    else ReadAllLists();
  } 
  //전체페이지 정보 읽기
  const ReadAllLists = async() => {
    const sendData = {pageNum: 0,pageSize: 0,searchData: varSearchData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_certification_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        let newArray = [];
        const pmax = datas.totalcount;
        if(datas.results?.length > 0) {
          const dataArray = datas.results;
          for(var i=0; i < dataArray.length; i++) {
            const lineObj = dataArray[i];
            var newData = {};
            newData['nums'] = pmax - i;
            newData['bh_company'] = lineObj.bh_company;
            newData['ch_name'] = lineObj.ch_name;
            newData['ch_month'] = PassedMonths(lineObj.ch_birthday)+" 개월";
            newData['ch_birthday'] = ChangeSimpleDateString(lineObj.ch_birthday);
            newData['ch_attendance'] = lineObj.ch_attendance;
            newData['vl_name'] = lineObj.vl_name;
            newData['ce_state'] = lineObj.ce_status===1?"발급대기":"발급완료";
            newData['ce_code'] = lineObj.ce_code;
            newData['ce_lang'] = lineObj.ce_lang===1?"국문":lineObj.ce_lang===2?"영문":"국영문";
            newData['ch_ename'] = lineObj.ch_ename;
            newData['bh_ecompany'] = lineObj.bh_ecompany;
            newData['ce_idate'] = ChangeSimpleDateString(lineObj.ce_idate);
            newData['ce_rdate'] = ChangeSimpleDateString(lineObj.ce_rdate);
            newData['ce_pdate'] = ChangeSimpleDateString(lineObj.ce_pdate);
            newData['ce_status'] = lineObj.ce_status;
            newData['ce_idx'] = lineObj.ce_idx;
            newArray.push(newData);
          }
        }
        MakeExcelFileForDownload(varColumnLists,newArray,'수료증');
      }
    });
  }

  //선택한 수료증 파일을 PDF로 저장
  const [varMakePDFFile, setMakePDFFile] = useState(false);
  const [varFileList, setFileList] = useState([]);
  const [varMakeList, setMakeList] = useState([]);
  const onSelecToPDFModeHandler = async(e) => {
    var iselected = selectedFlatRows.length;
    if(iselected === 0) {
      alert(`PDF로 저장할 수료증을 먼저 선택해주세요.`);
      return false;
    }
    let fileList = [];
    let makeList = [];
    for(let i=0; i < iselected; i++) {
      let sData = selectedFlatRows[i].values;
      let ce_idx = sData.ce_idx;
      let cData = varCertificationLists.find(el=>el.ce_idx === ce_idx);
      if(cData.ce_status === 2) {
        let newData = {mode:cData.ce_lang,image:`${process.env.REACT_APP_HOST}/certificate/${cData.ce_file}`}
        fileList.push(newData);
      } else {
        makeList.push(cData);
      }
    }
    setFileList(fileList);
    setMakeList(makeList);
    setMakePDFFile(true);
  }

  return (
    <div className="main-box" style={{marginTop:"30px",padding:"0px 10px"}}>
      <div className="btn-right">
      <div>
        <label htmlFor="tcount">검색건수</label>&nbsp;<span id="tcount">{varTotalCount}</span>&nbsp;건</div>&nbsp;&nbsp;&nbsp;
        {/* {varCertificationLists.length===0?null:
          <select value={varChangeStatus} style={{width:"90px"}} onChange={(e)=>onChangeStatusHandler(e)}>
            <option value={0}>발급선택</option>
            <option value={1}>발급대기</option>
            <option value={2}>발급완료</option>
          </select>
        }&nbsp;
        {varCertificationLists.length===0?null:<button onClick={e=>onChangeStatusAllHandler(e)} className="btn line">일괄적용</button>}&nbsp;&nbsp;&nbsp; */}
        {varCertificationLists.length===0?null:
          <div className="excel-area">
            <button onClick={e=>onSelecToPDFModeHandler(e)} className="btn line">수료증 PDF 저장</button>
            <button onClick={e=>onSelectDownloadModeHandler(e)} className="btn line">엑셀다운로드</button>
            <div className="excel-buttons hide">
              <button onClick={e=>onDownloadExcelHandler(e,1)}>현재페이지</button>
              <button onClick={e=>onDownloadExcelHandler(e,0)}>전체</button>
              <img src={removeIcon} alt="" className="excel-close-button" onClick={()=>CloseExcelPopup()}/>
            </div>
          </div>
        }
      </div>
      <div className="scroll-table" style={{border:"solid 1px #ccc",marginBottom:"10px"}}>
        <table className="list scroll delivery" {...getTableProps()}>
          {varColumnLists?.length===0?<thead></thead>:
            <thead>
              {headerGroups.map((headerGroup) => {
                const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
                return (
                  <tr key={key} {...restHeaderGroupProps}>
                    {headerGroup.headers.map((column,ii) => {
                      const { key, ...restColumn } = column.getHeaderProps({style:{width:ii===0?40:column.width}});
                      return (<th key={key} {...restColumn}>{column.render('Header')}</th>);
                    })}
                    <th style={{width:"90px"}}>상세</th>
                  </tr>
                )
              })}
            </thead>
          }
          {varCertificationLists?.length===0?<tbody><tr><td colSpan={11}>등록된 수료증 발급내역이 없습니다.</td></tr></tbody>:
            <tbody {...getTableBodyProps()}>
              {rows.map((row,i) => {
                prepareRow(row);
                const { key, ...restRowGroupProps } = row.getRowProps();
                return (
                  <tr key={key} {...restRowGroupProps}>
                    {row.cells.map((cell,i) => {
                      const { key, ...restCellProps } = cell.getCellProps();
                      return (<td key={key} {...restCellProps}>{cell.render('Cell')}</td>);
                    })}
                    <td>
                      <button onClick={e=>onShowDetailHandler(e,row.values.ce_idx)} style={{width:"80px"}} className="btn line black">상세</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          }
        </table>
      </div>
      <CertificationDetail varShowDetail={varShowDetail} varDetailInfo={varDetailInfo} setDetailInfo={setDetailInfo}
          varLevelList={varLevelList} CloseCertificationDetail={CloseCertificationDetail} GetCertificationList={GetCertificationList}/>

      <MakePDFCertifications varMakePDFFile={varMakePDFFile} setMakePDFFile={setMakePDFFile} varLevelList={varLevelList}
                varFileList={varFileList} setFileList={setFileList} varMakeList={varMakeList} setMakeList={setMakeList} />
    </div>
  )
}
export default CertificationSearchResult;